import teriyaki from './teriyakiHero.jpg';
import chopped from './choppedHero.png';

//key name must be same as appSource.

export default {
  teriyaki,
  chopped,
};
